import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

const REGISTRADO = 1;
const ENVIADO = 2;
const ANULADO = 3;
const IMPORTADO = 4;
export default function DetalleIngreso(props) {
    const renderColor = (row) => {
        if (row.idCompraEstado === REGISTRADO)
            return 'blue';
        if (row.idCompraEstado === ENVIADO)
            return 'green';
        if (row.idCompraEstado === ANULADO)
            return 'red';
        if (row.idCompraEstado === IMPORTADO)
            return 'orange';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            className={'table-reporte-venta-cliente'}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'nombreTipoComprobante',
                    sorter: true
                },

                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha Emisión',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimientoStr',
                    key: 'fechaVencimientoStr',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'nombreTipoDocumentoProveedor',
                    key: 'nombreTipoDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoProveedor',
                    key: 'numeroDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Razón Social',
                    dataIndex: 'razonSocialProveedor',
                    key: 'razonSocialProveedor',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Documento Vinculado',
                    dataIndex: 'documentoVinculo',
                    key: 'documentoVinculo',
                    sorter: true
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },

                {
                    title: 'Codigo Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },
                {
                    title: 'Marca',
                    dataIndex: 'marca',
                    key: 'marca',
                    sorter: true
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Valor Unitario',
                    dataIndex: 'valorUnitario',
                    key: 'valorUnitario',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Precio Unitario',
                    dataIndex: 'precioUnitario',
                    key: 'precioUnitario',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Igv',
                    dataIndex: 'igv',
                    key: 'igv',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreCompraEstado',
                    key: 'nombreCompraEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
